declare let mxConstants: any;
import * as util from '../styles.util';
import {StyleKeeper} from './style-keeper.model';

export class ImageStyleKeeper implements StyleKeeper {
  constructor(private readonly image) {}

  public mxCellCss({url}) {
    const result: any = {
      editable: 0,
      image: url,
      [mxConstants.STYLE_SHAPE]: mxConstants.SHAPE_IMAGE
    };

    if (this.image && this.image.position.r) {
      result.rotation = this.image.position.r;
    }

    if (this.image && this.image.locked) {
      result.locked = +!!+this.image.locked;
    }

    return util.objectToString(result, '=');
  }
}
